<template>
  <div>fileComparison</div>
</template>

<script>
export default {
  name: 'preOrder-customerOrderGoods',
}
</script>
